import React, { ReactElement } from 'react';
import { injectIntl, IntlShape } from 'react-intl';

import { Config } from 'containers/AppContainer/typings';
import { translate } from 'containers/services/translate';
import { getValueByCode } from 'containers/common/LegalProceedings/JudgementAdd/Recap/utils';
import messages from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/Expertise/messages';

export interface ExpertiseTypeProps {
  intl: IntlShape;
  expertiseList: Config[];
  expertiseId: string;
  index: number;
  children?: ReactElement | ReactElement[];
}

const ExpertiseType: React.FC<ExpertiseTypeProps> = (props): JSX.Element => {
  const { expertiseId, index } = props;

  return (
    <section className="expertise">
      <div className="expertise-title">
        {translate(messages.expertiseTitle, props, {
          number: index + 1,
        })}
      </div>
      <article className="field">
        <div className="label">{translate(messages.expertiseField, props)}</div>
        <div className="value">
          {getValueByCode(expertiseId, props.expertiseList)}
        </div>
      </article>
      <article>{props.children}</article>
    </section>
  );
};

export default injectIntl(ExpertiseType);
